import React from "react";
import { CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CButton, CSpinner, CForm, CFormLabel, CFormSelect } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilWarning } from "@coreui/icons";
import DatePicker from "react-datepicker";

const CameraModals = ({ t, i18n,
  recalculateModalVisible, setRecalculateModalVisible, recalculationDate, setRecalculationDate, handleRecalculate, isRecalculating,
  llmModalVisible, setLlmModalVisible, llmSyncDate, setLlmSyncDate, handleLlmSync, isLlmSyncing,
  moveModal, setMoveModal, groupedVehicleLogs, handleMoveLog,
  blurWarningModalVisible, setBlurWarningModalVisible, handleAcceptBlurDisable
}) => {
  return (
    <>
      <CModal alignment="center" visible={recalculateModalVisible} onClose={() => setRecalculateModalVisible(false)}>
        <CModalHeader><CModalTitle>{t("camera.recalc_modal_title")}</CModalTitle></CModalHeader>
        <CModalBody>
          <p>{t("camera.recalc_modal_body")}</p>
          <div className="d-flex flex-column">
            <label>{t("common.date_start")}:</label>
            <DatePicker selected={recalculationDate} onChange={setRecalculationDate} showTimeSelect className="form-control" dateFormat="dd.MM.yyyy HH:mm" locale={i18n.language === "ru" ? "ru" : "en"} />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setRecalculateModalVisible(false)} disabled={isRecalculating}>{t("common.cancel")}</CButton>
          <CButton color="primary" onClick={handleRecalculate} disabled={isRecalculating}>{isRecalculating ? <CSpinner size="sm" /> : t("camera.start_recalc")}</CButton>
        </CModalFooter>
      </CModal>

      <CModal alignment="center" visible={llmModalVisible} onClose={() => setLlmModalVisible(false)}>
        <CModalHeader><CModalTitle>{t("camera.llm_modal_title")}</CModalTitle></CModalHeader>
        <CModalBody>
          <p>{t("camera.llm_modal_body")}</p>
          <div className="d-flex flex-column">
            <label>{t("common.date_start")}:</label>
            <DatePicker selected={llmSyncDate} onChange={setLlmSyncDate} showTimeSelect className="form-control" dateFormat="dd.MM.yyyy HH:mm" locale={i18n.language === "ru" ? "ru" : "en"} />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setLlmModalVisible(false)} disabled={isLlmSyncing}>{t("common.cancel")}</CButton>
          <CButton color="primary" onClick={handleLlmSync} disabled={isLlmSyncing}>{isLlmSyncing ? <CSpinner size="sm" /> : t("camera.start_sync")}</CButton>
        </CModalFooter>
      </CModal>

      <CModal alignment="center" visible={moveModal.visible} onClose={() => setMoveModal({ visible: false, log: null, targetGroupId: "" })}>
        <CModalHeader><CModalTitle>{t("camera.move_modal_title")} #{moveModal.log?.id}</CModalTitle></CModalHeader>
        <CModalBody>
          <CForm>
            <CFormLabel>{t("camera.move_target_label")}</CFormLabel>
            <CFormSelect value={moveModal.targetGroupId} onChange={(e) => setMoveModal(p => ({ ...p, targetGroupId: e.target.value }))}>
              <option value="">{t("camera.move_option_default")}</option>
              {groupedVehicleLogs.filter(g => !g.logs.some(l => l.id === moveModal.log?.id)).map((g, i) => (
                <option key={g.id} value={g.logs[0].id}>{t("camera.vehicle_group_label", { index: i + 1 })} ({t("camera.visit_label", { id: g.logs[0].id })})</option>
              ))}
              <option value="new_group">{t("camera.move_option_new")}</option>
            </CFormSelect>
          </CForm>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setMoveModal({ visible: false, log: null, targetGroupId: "" })}>{t("common.cancel")}</CButton>
          <CButton color="primary" onClick={handleMoveLog}>{t("camera.move_btn")}</CButton>
        </CModalFooter>
      </CModal>

      <CModal alignment="center" visible={blurWarningModalVisible} onClose={() => setBlurWarningModalVisible(false)} backdrop="static">
        <CModalHeader closeButton={false}><CModalTitle className="text-danger"><CIcon icon={cilWarning} className="me-2" />{t("camera.blur_warning_title")}</CModalTitle></CModalHeader>
        <CModalBody><p className="text-justify" style={{ fontSize: "0.95rem", lineHeight: "1.5" }}>{t("camera.blur_warning_text")}</p></CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setBlurWarningModalVisible(false)}>{t("common.cancel")}</CButton>
          <CButton color="danger" onClick={handleAcceptBlurDisable} className="text-white">{t("camera.blur_accept")}</CButton>
        </CModalFooter>
      </CModal>
    </>
  );
};
export default CameraModals;